export const formatDateLocal = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const getCurrentSkyTheme = (date, skyThemes) => {
  const hour = date.getHours();
  if (hour >= 6 && hour < 12) return skyThemes.morning;
  if (hour >= 12 && hour < 18) return skyThemes.day;
  if (hour >= 18 && hour < 21) return skyThemes.sunset;
  return skyThemes.night;
};

export const getDailyVerse = (date = new Date()) => {
  const verses = [
    { text: "내 양을 먹이라", ref: "요한복음 21:17" },
    { text: "너는 말씀을 전파하라 때를 얻든지 못 얻든지 항상 힘쓰라", ref: "디모데후서 4:2" },
    { text: "두려워하지 말라 내가 너와 함께 함이라", ref: "이사야 41:10" },
    { text: "너희는 세상의 빛이라", ref: "마태복음 5:14" },
  ];

  const yearStart = new Date(date.getFullYear(), 0, 0);
  const dayIndex = Math.floor((date - yearStart) / 1000 / 60 / 60 / 24) % verses.length;
  return verses[dayIndex];
};

export const getGreetingInfo = (date, icons) => {
  const hour = date.getHours();
  if (hour >= 5 && hour < 9) return { text: "일찍 일어나셨네요! 기도로 여는 아침입니다.", icon: icons.sun };
  if (hour >= 9 && hour < 12) return { text: "상쾌한 아침이에요. 오늘 하루도 주님과 함께!", icon: icons.sun };
  if (hour >= 12 && hour < 14) return { text: "맛있는 점심 하셨나요? 잠시 쉬어가며 힘내세요!", icon: icons.sunwithface };
  if (hour >= 14 && hour < 18) return { text: "나른한 오후네요. 아이들을 생각하며 조금만 더!", icon: icons.sunwithface };
  if (hour >= 18 && hour < 22) return { text: "평안한 저녁 되세요. 오늘도 사역하느라 수고 많으셨습니다.", icon: icons.moon };
  return { text: "고요한 밤입니다. 오늘 하루도 동행하신 주님을 찬양합니다.", icon: icons.smilingfacewithheart };
};

export const getScheduleTypeName = (type) => {
  switch (type) {
    case "worship":
      return "예배";
    case "event":
      return "행사";
    case "meeting":
      return "회의";
    case "fellowship":
      return "교제";
    default:
      return "기타";
  }
};

export const getScheduleTypeColor = (type) => {
  switch (type) {
    case "worship":
      return "bg-purple-500 text-white shadow-purple-200";
    case "event":
      return "bg-orange-500 text-white shadow-orange-200";
    case "meeting":
      return "bg-blue-500 text-white shadow-blue-200";
    case "fellowship":
      return "bg-teal-500 text-white shadow-teal-200";
    default:
      return "bg-gray-500 text-white shadow-gray-200";
  }
};

export const getAttendanceStatus = (rate, icons) => {
  if (rate >= 90) return { icon: icons.fire, text: "부흥의 불길!" };
  if (rate >= 70) return { icon: icons.check, text: "안정적이에요" };
  if (rate >= 50) return { icon: icons.muscle, text: "조금 더 힘내요" };
  return { icon: icons.phone, text: "심방이 필요해요" };
};

export const getBudgetStatus = (remain, annualBudget, icons) => {
  if (annualBudget === 0) return { icon: icons.warning, text: "예산 미설정" };
  if (remain < 0) return { icon: icons.siren, text: "예산 초과!" };
  return { icon: icons.ok, text: "여유로워요" };
};

export const getDashboardDDayStatus = (filteredSchedules, icons, now = new Date()) => {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const upcoming = filteredSchedules
    .map((schedule) => {
      const date = new Date(schedule.date);
      date.setHours(0, 0, 0, 0);
      return { ...schedule, dateObj: date };
    })
    .filter((schedule) => schedule.dateObj >= today)
    .sort((a, b) => a.dateObj - b.dateObj)[0];

  if (upcoming) {
    const diffTime = upcoming.dateObj - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const dDayText = diffDays === 0 ? "D-Day" : `D-${diffDays}`;
    return { dDay: dDayText, text: upcoming.title, icon: icons.calendar };
  }

  return { dDay: "-", text: "일정 없음", icon: icons.calendar };
};

export const getScheduleDDay = (dateStr, now = new Date()) => {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const target = new Date(dateStr);
  target.setHours(0, 0, 0, 0);

  const diffTime = target - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return null;
  if (diffDays === 0) return { label: "D-Day", color: "bg-rose-500" };
  if (diffDays <= 3) return { label: `D-${diffDays}`, color: "bg-rose-500" };
  if (diffDays <= 7) return { label: `D-${diffDays}`, color: "bg-orange-500" };
  return { label: `D-${diffDays}`, color: "bg-[#354F38]" };
};
